import { render, staticRenderFns } from "./MyQuestionCard.vue?vue&type=template&id=8b3ca272"
import script from "./MyQuestionCard.vue?vue&type=script&lang=js"
export * from "./MyQuestionCard.vue?vue&type=script&lang=js"
import style0 from "./MyQuestionCard.vue?vue&type=style&index=0&id=8b3ca272&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports